
import { Section } from "./data-types";

export const EventAwarenessWeek: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Geography Awareness Week",
						content: () => [
							<p>
								Geography Awareness Week is an annual event that usually takes place in the third week of November.
								It is designed to engage the public with geographical concepts and the interconnectedness of humans
								and the environment. Events can include public talks, school visits, interactive displays,
								and online activities, with this year's theme (2025) focusing on ‘Making Spaces of Possibility’
								through activities like mapping and panel discussions on the role of geography in education.
							</p>,
							<p>
								Key issues of focus for the Geographical Society of Ireland are:
							</p>,
							<p>
								Focus areas: Geography in education, climate action, conservation, community, and global issues.
							</p>,
							<p>
								For further information, see: <a href="https://www.aag.org/geography-awareness-week-2025/" target="_blank" rel="noopener noreferrer">https://www.aag.org/geography-awareness-week-2025/</a>
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/2.jpg"
						},
					},
				}
			]
		}
	]
}
